import { render, staticRenderFns } from "./qa-legend.vue?vue&type=template&id=1d3697c0&scoped=true"
import script from "./qa-legend.vue?vue&type=script&lang=js"
export * from "./qa-legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3697c0",
  null
  
)

export default component.exports